import { entityLabel, isTableEntity } from '@entities/helpers';
import { WizardBasketData, WizardContainer } from '@wizard/models';
import { WizardBasketDatas, WizardBasketDataType } from '@wizard/types';
import { WizardItemEntity } from '../models';
import { WizardPanelDataSourceMapType } from '../types';

export function normalizeWizardBasketItems(wizardItemList: WizardItemEntity[]): WizardBasketData {
  const groupMap: WizardPanelDataSourceMapType = new Map<WizardBasketDataType, WizardContainer[]>();

  [...wizardItemList]
    .forEach(item => {
      let itemGroup: WizardBasketDataType;

      switch (item.type) {
        case 'Report':
          itemGroup = WizardBasketDatas.reports;
          break;
        case 'Semantic':
          itemGroup = WizardBasketDatas.semantics;
          break;
        case 'Datamart':
          itemGroup = WizardBasketDatas.datamarts;
          break;
        case 'DimensionView':
        case 'FactView':
        case 'FunctionTable':
        case 'TechnicalView':
        case 'DataSource':
        case 'View':
          itemGroup = WizardBasketDatas.views;
          break;
        case 'Table':
          itemGroup = WizardBasketDatas.tables;
          break;
        default:
          break;
      }

      if (!groupMap.has(itemGroup)) { groupMap.set(itemGroup, []); }

      const groupData = groupMap.get(itemGroup);
      const versionId = item.versionId;
      const referentialId = item.referentialId;
      const dataItemList = item.items.map(i => {
        return {
          id: i.id,
          type: i.type,
          name: entityLabel(i),
          comment: i.comment || null,
          items: null,
          versionId,
          referentialId,
        } as WizardContainer;
      }) as WizardContainer[];

      const dataItem: WizardContainer = {
        id: item.id,
        type: item.type,
        name: isTableEntity(item)
          ? item.technicalName
          : entityLabel(item),
        comment: null,
        items: dataItemList,
        referentialId,
        versionId,
      };

      groupData.push(dataItem);
      groupMap.set(itemGroup, groupData);
    });

  const wizardBasketData: WizardBasketData = {
    reports: [],
    semantics: [],
    datamarts: [],
    views: [],
    tables: [],
  };

  Array.from(groupMap.entries()).forEach(entries => wizardBasketData[`${entries[0]}`] = entries[1]);

  return wizardBasketData;
}
